import PropTypes from "prop-types";
import React, { useEffect } from "react";
import LoadMask from "Utils/LoadMask/LoadMask";
import { activeFormatter } from "Utils/Acciones/Acciones";
import { BreakLine, tableOptions } from "Utils/tableOptions";
import { RenderCurrency, RenderDate } from "Utils/renderField/renderReadField";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { FiltrosReportes } from "../../../Utils/FiltrosReportes";

const ListadoReciboCuentaCobrar = ({
    // state
    loader,
    data,
    fecha_vencimiento_inicial,
    fecha_vencimiento_final,
    estado_descarga,
    vendedor,
    cliente,
    totales_rcc,

    // bind
    setFecha,
    descargarListado,
    aplicarFiltros,
    setVendedor,
    setCliente,
    limpiarFiltros,
    page,
    listarReporteRecibo,
    sortChange,
}) => {
    //  OPCIONES
    const options = _.cloneDeep(tableOptions);
    options.noDataText = loader ? "Cargando..." : options.noDataText;
    options.page = page;
    options.onPageChange = listarReporteRecibo;
    options.onSortChange = sortChange;

    useEffect(() => {
        return () => {
            const enReporteRecibo = true;
            limpiarFiltros(enReporteRecibo);
        };
    }, []);

    return (
        <div className="mb-5">
            <div className="row">
                {/* FILTRO */}
                <div className="col-12">
                    <FiltrosReportes
                        fecha_inicial={fecha_vencimiento_inicial}
                        fecha_final={fecha_vencimiento_final}
                        cliente={cliente}
                        vendedor={vendedor}
                        setFechaInicial={setFecha}
                        setFechaFinal={setFecha}
                        setCliente={setCliente}
                        setVendedor={setVendedor}
                        aplicarFiltros={aplicarFiltros}
                        filtroReciboCC
                    />
                </div>

                <div className="col-12">
                    <div className="grid-container px-4">
                        <div className="d-flex justify-content-between border-bottom mb-3">
                            <h1 className="title-text">Reporte</h1>

                            <button
                                className="ml-3 mt-3 mt-md-0 mt-lg-0 btn btn-secondary mb-sm-10 align-self-center"
                                disabled={estado_descarga}
                                onClick={() => {
                                    const esReporteRecibo = true;
                                    descargarListado(esReporteRecibo);
                                }}
                            >
                                <em
                                    className={`fa ${
                                        estado_descarga
                                            ? "fa-spinner fa-pulse"
                                            : "fa-download"
                                    }`}
                                ></em>
                                &nbsp;Descargar Listado
                            </button>
                        </div>

                        <LoadMask loading={loader} light blur>
                            <BootstrapTable
                                data={loader ? [] : data.results}
                                remote
                                pagination
                                hover
                                fetchInfo={{ dataTotalSize: data.count }}
                                options={options}
                            >
                                <TableHeaderColumn
                                    dataField="fecha_pago"
                                    dataFormat={cell => <RenderDate value={cell} />}
                                >
                                    Fecha de pago
                                </TableHeaderColumn>

                                <TableHeaderColumn dataField="codigo">
                                    Correlativo de pago
                                </TableHeaderColumn>

                                <TableHeaderColumn dataField="codigo_venta">
                                    Correlativo de Venta
                                </TableHeaderColumn>

                                <TableHeaderColumn
                                    dataField="fecha_venta"
                                    dataFormat={cell => <RenderDate value={cell} />}
                                >
                                    Fecha de Venta
                                </TableHeaderColumn>

                                <TableHeaderColumn
                                    dataField="vendedor"
                                    dataFormat={(cell) => cell.first_name}
                                >
                                    Vendedor
                                </TableHeaderColumn>

                                <TableHeaderColumn
                                    dataField="cliente"
                                    dataFormat={(cell) => cell.nombre}
                                >
                                    Cliente
                                </TableHeaderColumn>

                                <TableHeaderColumn dataField="observaciones">
                                    observaciones
                                </TableHeaderColumn>

                                <TableHeaderColumn
                                    dataAlign="right"
                                    dataField="total"
                                    dataFormat={(cell) => (
                                        <RenderCurrency value={cell} />
                                    )}
                                >
                                    Total pagado
                                </TableHeaderColumn>

                                <TableHeaderColumn
                                    dataField="id"
                                    width="10%"
                                    tdStyle={BreakLine}
                                    thStyle={BreakLine}
                                    isKey
                                    dataAlign="center"
                                    dataFormat={(cell, row) => {
                                        if (row.es_pago_multiple) {
                                            return activeFormatter({
                                                ver: "/reporte_recibos_cuenta_por_cobrar/documento_pago_multiple",
                                            })(row.id_venta, row);
                                        } else {
                                            return activeFormatter({
                                                ver: "/reporte_recibos_cuenta_por_cobrar/documento",
                                            })(cell, row);
                                        }
                                    }}
                                >
                                    Acciones
                                </TableHeaderColumn>
                            </BootstrapTable>
                            <div className="d-flex justify-content-between">
                                <h1 className="title-text">Total</h1>
                                <RenderCurrency
                                    value={totales_rcc.total}
                                    className="title-text"
                                />
                            </div>
                        </LoadMask>
                    </div>
                </div>
            </div>
        </div>
    );
};

ListadoReciboCuentaCobrar.propTypes = {
    listarReporteRecibo: PropTypes.func.isRequired,
};

export default ListadoReciboCuentaCobrar;
